const getQuickPhotoItems = car => {
	if (!car) return []

	// 列表和推荐卡片的图片直接挂在商品上；详情接口则放在 photo 下。
	// 仅在 quick_images 为空时回退 commodity_head_photo，确保快速上架车始终有封面可展示。
	if (Array.isArray(car.quick_images)) return car.quick_images
	if (car.photo && Array.isArray(car.photo.quick_images)) return car.photo.quick_images

	return []
}

const normalizePhotoItems = items =>
	items
		.filter(Boolean)
		.map(item => ({
			...item,
			thpf_url: item.thpf_url || item.url
		}))
		.filter(item => item.thpf_url)

export const isFastListing = car => {
	return Boolean(
		car && (car.fast_listing === true || (car.photo && car.photo.fast_listing === true))
	)
}

export const getFastListingPhotos = car => {
	const quickPhotos = normalizePhotoItems(getQuickPhotoItems(car))

	if (quickPhotos.length) return quickPhotos

	const fallback =
		car && (car.commodity_head_photo || (car.basic && car.basic.commodity_head_photo))
	return fallback ? [{ url: fallback, thpf_url: fallback, isHeadPhotoFallback: true }] : []
}

export const getFastListingCover = car => {
	const [cover] = getFastListingPhotos(car)
	return cover ? cover.thpf_url : ''
}
